import { SvgScissors } from '@loomhq/lens';
import React from 'react';
import { connect, useSelector } from 'react-redux';

import {
  ROLLOUT_WEAVE,
  VARIANT,
  inactiveDefaultVariations,
} from 'constants/featureFlag';
import { VIDEO_ENTER_TRIM_MODE } from 'constants/hotkeys';
import { V4 } from 'constants/recordingVersions';
import { selectRecordingVersion } from 'selectors/videoPlayer';
import * as device from 'utilities/device';

import { useFeatureFlagValue } from 'hooks/featureFlag';

import CollapsibleSideButton from '../collapsible-side-button';

import FeatureFlaggedComponent from 'components/feature-flag-wrapper';

const TrimModeButton = ({
  onClick,
  enterTrimEnabled,
  isCollapsed,
  disabled,
  currentUserCanEdit,
}) => {
  const recordingVersion = useSelector(selectRecordingVersion);

  const weaveFlagValue = useFeatureFlagValue(ROLLOUT_WEAVE);
  const rolloutWeave = VARIANT.includes(weaveFlagValue);

  // NOTE(weave): temporarily enabling this if you are using Weave
  enterTrimEnabled = enterTrimEnabled || rolloutWeave;

  const userCanEdit = currentUserCanEdit;

  return (
    !device.isMobile &&
    userCanEdit && (
      <CollapsibleSideButton
        icon={<SvgScissors />}
        isCollapsed={isCollapsed}
        isDisabled={disabled || !enterTrimEnabled}
        onClick={enterTrimEnabled ? onClick : undefined}
      >
        {/** Exclude the V4 videos */}
        {recordingVersion === V4 ? (
          <>({VIDEO_ENTER_TRIM_MODE[0]}) Trim video</>
        ) : (
          <>
            <FeatureFlaggedComponent
              flag={ROLLOUT_WEAVE}
              activationValues={inactiveDefaultVariations}
            >
              ({VIDEO_ENTER_TRIM_MODE[0]}) Trim video
            </FeatureFlaggedComponent>
            <FeatureFlaggedComponent
              flag={ROLLOUT_WEAVE}
              activationValues={VARIANT}
            >
              ({VIDEO_ENTER_TRIM_MODE[0]}) Trim and add clips
            </FeatureFlaggedComponent>
          </>
        )}
      </CollapsibleSideButton>
    )
  );
};

const mapStateToProps = state => {
  const { player_ready, video } = state.share_video;

  const { processing_information = {} } = video;
  const { trim_id, trim_progress } = processing_information;

  // the user should be able to enter trim mode if the player is ready or if
  // a trim job is progressing
  const enterTrimEnabled =
    player_ready || (trim_id != null && trim_progress !== 100);

  return {
    enterTrimEnabled,
    currentUserCanEdit: video.currentUserCanEdit,
  };
};

export default connect(mapStateToProps)(TrimModeButton);
